import DedupBaseIcon from "@core/Modules/JourneyBuilder/Assets/Checkpoints/icon_dedup_B.png";

import Checkpoint from './checkpoint';
import {resolveOperatorByName} from "./checkpoint-operator-definitions";
import { getFilterLabelMap, ListElementBuilder } from "./util";

export default class DeduplicationBaseCheckpoint extends Checkpoint {
    constructor() {
        super('dedupBase', 'JourneyBuilder_Checkpoint_DeduplicationBase', 'JourneyBuilder_Checkpoint_DeduplicationBase_Description', { iconPath: DedupBaseIcon });
    }

    get defaultOrder() {
        return 2;
    }

    buildTooltip(connection) {
        const config = this.readForConnection(connection);

        const tooltipContent = new Promise(async resolve => {
            const filterLabelMap = await getFilterLabelMap();
            let content = '';

            if(!config || !config.conditions) {
                return content;
            }

            config.conditions.forEach(group => {
                const builder = new ListElementBuilder();

                group.forEach(condition => {
                    builder.add(`${condition.field} ${resolveOperatorByName(condition.operator).label}`);
                    const subBuilder = builder.createdNestedList();
                    condition.value.forEach(
                        audienceId => subBuilder.add(filterLabelMap.get(audienceId))
                    );
                });

                content += builder;
            });

            resolve(content);
        });

        return {
            title: 'Deduplication checkpoint (base)',
            content: tooltipContent
        }
    }
}